import { render } from "./BannerCheckMatch.vue?vue&type=template&id=77639157&scoped=true&ts=true"
import script from "./BannerCheckMatch.ts?vue&type=script&lang=ts&external"
export * from "./BannerCheckMatch.ts?vue&type=script&lang=ts&external"

import "../Banner.scss?vue&type=style&index=0&id=77639157&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77639157"]])

export default __exports__